// Sample event payloads, one per shipped rule.
//
// Generated from Docs/myLedger-External-Integration-API-v1.0.docx, so what an operator tests
// here is byte-for-byte what a third-party developer was handed. If the two drift, someone
// debugs a payload the other side never sent.
//
// Regenerate with: python tools/integration-doc/export_samples.py

export const SAMPLE_BY_EVENT: Record<string, string> = {
  "bottle_deposit.collected": `{
  "eventType": "bottle_deposit.collected",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "DEP-C-4410",
  "idempotencyKey": "AcmeWMS:bottle_deposit.collected:DEP-C-4410",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "totals": {
    "amount": 2400.0
  },
  "references": {
    "sourceDocumentType": "DepositCollection",
    "sourceDocumentNumber": "DEP-C-4410",
    "locationExternalId": "STORE-01"
  }
}`,
  "bottle_deposit.refunded": `{
  "eventType": "bottle_deposit.refunded",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "DEP-R-4411",
  "idempotencyKey": "AcmeWMS:bottle_deposit.refunded:DEP-R-4411",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "totals": {
    "amount": 1800.0
  },
  "references": {
    "sourceDocumentType": "DepositRefund",
    "sourceDocumentNumber": "DEP-R-4411",
    "locationExternalId": "STORE-01"
  }
}`,
  "card.settlement": `{
  "eventType": "card.settlement",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Treasury",
  "eventId": "SETT-20260721-VISA",
  "idempotencyKey": "AcmeWMS:card.settlement:SETT-20260721-VISA",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "totals": {
    "grossAmount": 250000.0,
    "commissionAmount": 5000.0,
    "netAmount": 245000.0
  },
  "references": {
    "sourceDocumentType": "CardSettlement",
    "sourceDocumentNumber": "SETT-20260721-VISA",
    "locationExternalId": "STORE-01"
  }
}`,
  "customer_invoice.posted": `{
  "eventType": "customer_invoice.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "AR",
  "eventId": "SI-20260721-018",
  "idempotencyKey": "AcmeWMS:customer_invoice.posted:SI-20260721-018",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "dueDate": "2026-08-20",
  "customerReference": "PO-CUST-8891",
  "party": {
    "type": "Customer",
    "externalId": "CUS-1042",
    "name": "Ceylon Retail (Pvt) Ltd"
  },
  "totals": {
    "net": 120000.0,
    "taxTotal": 21600.0,
    "grandTotal": 141600.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-1",
      "categoryExternalId": "CAT-DRY",
      "qty": 40,
      "unitPrice": 3000.0,
      "lineNet": 120000.0,
      "taxCode": "VAT18",
      "taxAmount": 21600.0
    }
  ],
  "references": {
    "sourceDocumentType": "CustomerInvoice",
    "sourceDocumentNumber": "SI-20260721-018",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "customer_receipt.posted": `{
  "eventType": "customer_receipt.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "AR",
  "eventId": "RCT-8814",
  "idempotencyKey": "AcmeWMS:customer_receipt.posted:RCT-8814",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "party": {
    "type": "Customer",
    "externalId": "CUS-1042",
    "name": "Ceylon Retail (Pvt) Ltd"
  },
  "totals": {
    "amount": 141600.0
  },
  "allocations": [
    {
      "invoiceDocumentNo": "SI-20260721-018"
    }
  ],
  "references": {
    "sourceDocumentType": "CustomerReceipt",
    "sourceDocumentNumber": "RCT-8814",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "goods_return.posted": `{
  "eventType": "goods_return.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Inventory",
  "eventId": "GRT-1180",
  "idempotencyKey": "AcmeWMS:goods_return.posted:GRT-1180",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "party": {
    "type": "Supplier",
    "externalId": "SUP-8842",
    "name": "Global Foods (Pvt) Ltd"
  },
  "totals": {
    "goodsNet": 42000.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-1",
      "qty": 16.8,
      "unitCost": 2500.0,
      "lineNet": 42000.0
    }
  ],
  "references": {
    "sourceDocumentType": "GoodsReturn",
    "sourceDocumentNumber": "GRT-1180",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "goods_return.reversed": `{
  "eventType": "goods_return.reversed",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Inventory",
  "eventId": "GRT-1180-REV",
  "idempotencyKey": "AcmeWMS:goods_return.reversed:GRT-1180-REV",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "party": {
    "type": "Supplier",
    "externalId": "SUP-8842",
    "name": "Global Foods (Pvt) Ltd"
  },
  "totals": {
    "goodsNet": 42000.0
  },
  "references": {
    "sourceDocumentType": "GoodsReturnReversal",
    "sourceDocumentNumber": "GRT-1180-REV",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "grn.posted": `{
  "eventType": "grn.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Inventory",
  "eventId": "GRN-4471",
  "idempotencyKey": "AcmeWMS:grn.posted:GRN-4471",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "party": {
    "type": "Supplier",
    "externalId": "SUP-8842",
    "name": "Global Foods (Pvt) Ltd"
  },
  "totals": {
    "goodsNet": 265000.0,
    "goodsOnlyNet": 250000.0,
    "chargesNet": 15000.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-1",
      "categoryExternalId": "CAT-DRY",
      "qty": 100,
      "unitCost": 2500.0,
      "lineNet": 250000.0
    }
  ],
  "references": {
    "sourceDocumentType": "GoodsReceipt",
    "sourceDocumentNumber": "GRN-4471",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "grn.reversed": `{
  "eventType": "grn.reversed",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Inventory",
  "eventId": "GRN-4471-REV",
  "idempotencyKey": "AcmeWMS:grn.reversed:GRN-4471-REV",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "party": {
    "type": "Supplier",
    "externalId": "SUP-8842",
    "name": "Global Foods (Pvt) Ltd"
  },
  "totals": {
    "goodsNet": 265000.0,
    "goodsOnlyNet": 250000.0,
    "chargesNet": 15000.0
  },
  "references": {
    "sourceDocumentType": "GoodsReceiptReversal",
    "sourceDocumentNumber": "GRN-4471-REV",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "inventory.gain": `{
  "eventType": "inventory.gain",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Inventory",
  "eventId": "ADJ-7780",
  "idempotencyKey": "AcmeWMS:inventory.gain:ADJ-7780",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "adjustmentReasonExternalId": "REASON-COUNT",
  "totals": {
    "value": 4250.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-1",
      "qty": 1.7,
      "unitCost": 2500.0,
      "lineValue": 4250.0
    }
  ],
  "references": {
    "sourceDocumentType": "StockAdjustment",
    "sourceDocumentNumber": "ADJ-7780",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "inventory.loss": `{
  "eventType": "inventory.loss",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Inventory",
  "eventId": "ADJ-7781",
  "idempotencyKey": "AcmeWMS:inventory.loss:ADJ-7781",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "adjustmentReasonExternalId": "REASON-SHRINK",
  "totals": {
    "value": 18750.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-1",
      "qty": 7.5,
      "unitCost": 2500.0,
      "lineValue": 18750.0
    }
  ],
  "references": {
    "sourceDocumentType": "StockAdjustment",
    "sourceDocumentNumber": "ADJ-7781",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "inventory.wastage": `{
  "eventType": "inventory.wastage",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Inventory",
  "eventId": "WST-2210",
  "idempotencyKey": "AcmeWMS:inventory.wastage:WST-2210",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "adjustmentReasonExternalId": "REASON-EXPIRED",
  "totals": {
    "value": 9600.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-7",
      "categoryExternalId": "CAT-FRESH",
      "qty": 32,
      "unitCost": 300.0,
      "lineValue": 9600.0
    }
  ],
  "references": {
    "sourceDocumentType": "Wastage",
    "sourceDocumentNumber": "WST-2210",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "loyalty.earned": `{
  "eventType": "loyalty.earned",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "LOY-E-20260721",
  "idempotencyKey": "AcmeWMS:loyalty.earned:LOY-E-20260721",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "loyaltyProgramId": "CLUB-STD",
  "totals": {
    "pointsValue": 3200.0
  },
  "references": {
    "sourceDocumentType": "LoyaltyAccrual",
    "sourceDocumentNumber": "LOY-E-20260721",
    "locationExternalId": "STORE-01"
  }
}`,
  "loyalty.redeemed": `{
  "eventType": "loyalty.redeemed",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "LOY-R-20260721",
  "idempotencyKey": "AcmeWMS:loyalty.redeemed:LOY-R-20260721",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "loyaltyProgramId": "CLUB-STD",
  "totals": {
    "redeemedValue": 1450.0
  },
  "references": {
    "sourceDocumentType": "LoyaltyRedemption",
    "sourceDocumentNumber": "LOY-R-20260721",
    "locationExternalId": "STORE-01"
  }
}`,
  "pos_sales.daily_summary": `{
  "eventType": "pos_sales.daily_summary",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "DAY-STORE01-20260721",
  "idempotencyKey": "AcmeWMS:pos_sales.daily_summary:DAY-STORE01-20260721",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "tenders": [
    {
      "modeCode": "CASH",
      "amount": 100000.0,
      "mdrRate": 0
    },
    {
      "modeCode": "VISA",
      "amount": 50000.0,
      "mdrRate": 0.02
    }
  ],
  "revenueByCategory": [
    {
      "categoryExternalId": "CAT-DRY",
      "net": 120000.0
    },
    {
      "categoryExternalId": "CAT-BEV",
      "net": 20000.0
    }
  ],
  "totals": {
    "taxTotal": 10000.0,
    "cogsTotal": 84000.0,
    "grossAmount": 150000.0
  },
  "references": {
    "sourceDocumentType": "DailySummary",
    "sourceDocumentNumber": "DAY-STORE01-20260721",
    "locationExternalId": "STORE-01"
  }
}`,
  "sale.credit": `{
  "eventType": "sale.credit",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "POS-CR-55120",
  "idempotencyKey": "AcmeWMS:sale.credit:POS-CR-55120",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "dueDate": "2026-08-05",
  "party": {
    "type": "Customer",
    "externalId": "CUS-1042",
    "name": "Ceylon Retail (Pvt) Ltd"
  },
  "totals": {
    "net": 18500.0,
    "taxTotal": 3330.0,
    "grandTotal": 21830.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-9",
      "categoryExternalId": "CAT-BEV",
      "qty": 37,
      "unitPrice": 500.0,
      "lineNet": 18500.0,
      "taxCode": "VAT18",
      "taxAmount": 3330.0
    }
  ],
  "references": {
    "sourceDocumentType": "CreditSale",
    "sourceDocumentNumber": "POS-CR-55120",
    "locationExternalId": "STORE-01"
  }
}`,
  "sale.returned": `{
  "eventType": "sale.returned",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "RET-33920",
  "idempotencyKey": "AcmeWMS:sale.returned:RET-33920",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "revenueByCategory": [
    {
      "categoryExternalId": "CAT-DRY",
      "net": 5000.0
    }
  ],
  "tenders": [
    {
      "modeCode": "CASH",
      "amount": 5900.0
    }
  ],
  "totals": {
    "taxTotal": 900.0,
    "cogsTotal": 3000.0
  },
  "references": {
    "sourceDocumentType": "SaleReturn",
    "sourceDocumentNumber": "RET-33920",
    "locationExternalId": "STORE-01"
  }
}`,
  "sale.voided": `{
  "eventType": "sale.voided",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "VOID-33921",
  "idempotencyKey": "AcmeWMS:sale.voided:VOID-33921",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "revenueByCategory": [
    {
      "categoryExternalId": "CAT-BEV",
      "net": 1200.0
    }
  ],
  "tenders": [
    {
      "modeCode": "VISA",
      "amount": 1416.0
    }
  ],
  "totals": {
    "taxTotal": 216.0,
    "cogsTotal": 700.0
  },
  "references": {
    "sourceDocumentType": "SaleVoid",
    "sourceDocumentNumber": "VOID-33921",
    "locationExternalId": "STORE-01"
  }
}`,
  "sfa_collection.posted": `{
  "eventType": "sfa_collection.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "FieldSales",
  "eventId": "SFA-COL-9902",
  "idempotencyKey": "AcmeWMS:sfa_collection.posted:SFA-COL-9902",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "party": {
    "type": "Customer",
    "externalId": "CUS-2201",
    "name": "Nugegoda Superstore"
  },
  "totals": {
    "amount": 54280.0
  },
  "allocations": [
    {
      "invoiceDocumentNo": "SFA-INV-3391"
    }
  ],
  "references": {
    "sourceDocumentType": "FieldCollection",
    "sourceDocumentNumber": "SFA-COL-9902",
    "locationExternalId": "VAN-12"
  }
}`,
  "sfa_credit_note.posted": `{
  "eventType": "sfa_credit_note.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "FieldSales",
  "eventId": "SFA-CN-441",
  "idempotencyKey": "AcmeWMS:sfa_credit_note.posted:SFA-CN-441",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "sourceInvoiceNumber": "SFA-INV-3391",
  "creditNoteNumber": "CN-441",
  "reason": "Damaged in transit — 4 cases returned",
  "party": {
    "type": "Customer",
    "externalId": "CUS-2201",
    "name": "Nugegoda Superstore"
  },
  "totals": {
    "net": 2000.0,
    "taxTotal": 360.0,
    "grandTotal": 2360.0
  },
  "references": {
    "sourceDocumentType": "FieldCreditNote",
    "sourceDocumentNumber": "SFA-CN-441",
    "locationExternalId": "VAN-12"
  }
}`,
  "sfa_invoice.posted": `{
  "eventType": "sfa_invoice.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "FieldSales",
  "eventId": "SFA-INV-3391",
  "idempotencyKey": "AcmeWMS:sfa_invoice.posted:SFA-INV-3391",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "dueDate": "2026-08-04",
  "customerReference": "ROUTE-12",
  "party": {
    "type": "Customer",
    "externalId": "CUS-2201",
    "name": "Nugegoda Superstore"
  },
  "totals": {
    "net": 46000.0,
    "taxTotal": 8280.0,
    "grandTotal": 54280.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-3",
      "categoryExternalId": "CAT-BEV",
      "qty": 92,
      "unitPrice": 500.0,
      "lineNet": 46000.0,
      "taxCode": "VAT18",
      "taxAmount": 8280.0
    }
  ],
  "references": {
    "sourceDocumentType": "VanSalesInvoice",
    "sourceDocumentNumber": "SFA-INV-3391",
    "locationExternalId": "VAN-12"
  }
}`,
  "supplier_invoice.approved": `{
  "eventType": "supplier_invoice.approved",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Purchasing",
  "eventId": "INV-99231",
  "idempotencyKey": "AcmeWMS:supplier_invoice.approved:INV-99231",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "supplierInvoiceNumber": "GF/2026/4471",
  "dueDate": "2026-08-20",
  "party": {
    "type": "Supplier",
    "externalId": "SUP-8842",
    "name": "Global Foods (Pvt) Ltd"
  },
  "totals": {
    "goodsNet": 265000.0,
    "goodsOnlyNet": 250000.0,
    "chargesNet": 15000.0,
    "taxTotal": 47700.0
  },
  "lines": [
    {
      "lineNo": 1,
      "productExternalId": "SKU-1",
      "categoryExternalId": "CAT-DRY",
      "qty": 100,
      "unitPrice": 2500.0,
      "lineNet": 250000.0,
      "taxCode": "VAT18",
      "taxAmount": 45000.0
    }
  ],
  "references": {
    "sourceDocumentType": "SupplierInvoice",
    "sourceDocumentNumber": "INV-99231",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "supplier_payment.posted": `{
  "eventType": "supplier_payment.posted",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Payments",
  "eventId": "PAY-7712",
  "idempotencyKey": "AcmeWMS:supplier_payment.posted:PAY-7712",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "party": {
    "type": "Supplier",
    "externalId": "SUP-8842",
    "name": "Global Foods (Pvt) Ltd"
  },
  "totals": {
    "amount": 312700.0
  },
  "allocations": [
    {
      "invoiceDocumentNo": "INV-99231"
    }
  ],
  "references": {
    "sourceDocumentType": "SupplierPayment",
    "sourceDocumentNumber": "PAY-7712",
    "locationExternalId": "WH-COL-01"
  }
}`,
  "tender.settlement": `{
  "eventType": "tender.settlement",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "Treasury",
  "eventId": "TSET-20260721-01",
  "idempotencyKey": "AcmeWMS:tender.settlement:TSET-20260721-01",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "totals": {
    "grossAmount": 82000.0,
    "mdrAmount": 1640.0,
    "netAmount": 80360.0
  },
  "references": {
    "sourceDocumentType": "TenderSettlement",
    "sourceDocumentNumber": "TSET-20260721-01",
    "locationExternalId": "STORE-01"
  }
}`,
  "voucher.redeemed": `{
  "eventType": "voucher.redeemed",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "VCH-R-7782",
  "idempotencyKey": "AcmeWMS:voucher.redeemed:VCH-R-7782",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "voucherGroupId": "GIFT-STD",
  "totals": {
    "redeemedAmount": 5900.0,
    "net": 5000.0,
    "taxTotal": 900.0,
    "cogs": 3000.0
  },
  "references": {
    "sourceDocumentType": "VoucherRedemption",
    "sourceDocumentNumber": "VCH-R-7782",
    "locationExternalId": "STORE-01"
  }
}`,
  "voucher.sold": `{
  "eventType": "voucher.sold",
  "sourceSystem": "AcmeWMS",
  "sourceModule": "POS",
  "eventId": "VCH-S-7781",
  "idempotencyKey": "AcmeWMS:voucher.sold:VCH-S-7781",
  "businessDate": "2026-07-21",
  "currencyCode": "LKR",
  "exchangeRate": 1,
  "financialYearCode": "FY2026",
  "financialPeriodCode": "2026-07",
  "voucherGroupId": "GIFT-STD",
  "tenders": [
    {
      "modeCode": "CASH",
      "amount": 5000.0
    }
  ],
  "totals": {
    "voucherValue": 5000.0
  },
  "references": {
    "sourceDocumentType": "VoucherSale",
    "sourceDocumentNumber": "VCH-S-7781",
    "locationExternalId": "STORE-01"
  }
}`,
};

/** Falls back to a minimal envelope for a rule whose event type has no shipped sample. */
export const sampleFor = (eventType: string): string =>
  SAMPLE_BY_EVENT[eventType] ??
  JSON.stringify(
    {
      eventType,
      businessDate: new Date().toISOString().slice(0, 10),
      financialYearCode: 'FY2026',
      financialPeriodCode: new Date().toISOString().slice(0, 7),
      currencyCode: 'LKR',
      exchangeRate: 1,
      references: { sourceDocumentNumber: 'TEST-001' },
      totals: {},
    },
    null,
    2,
  );
